import TabbedCarousels from './lib/TabbedCarousels';

export default TabbedCarousels;
